import localforage from 'localforage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type Region = 'china' | 'global';

interface RegionState {
  regionPreference: Region | null;
  _hasHydrated: boolean;
}

interface RegionActions {
  setRegionPreference: (region: Region | null) => void;
}

type RegionStore = RegionState & RegionActions;

const initialRegionState: RegionState = {
  regionPreference: null,
  _hasHydrated: false,
};

const localForageRegionStorage = localforage.createInstance({
  name: 'regionStore',
});

export const useRegionStore = create<RegionStore>()(
  persist(
    (set) => ({
      ...initialRegionState,

      setRegionPreference: (region) => {
        set({ regionPreference: region });
      },
    }),
    {
      name: 'regionStore',
      storage: createJSONStorage(() => localForageRegionStorage),
      partialize: (state) => ({
        regionPreference: state.regionPreference,
      }),
      onRehydrateStorage: () => (state, error) => {
        if (state) {
          state._hasHydrated = true;
        } else {
          useRegionStore.setState({ _hasHydrated: true });
        }
        if (error) {
          console.warn('Failed to rehydrate region store:', error);
        }
      },
    }
  )
);

// Selectors
export const selectRegionPreference = (state: RegionStore) => state.regionPreference;
export const selectRegionHasHydrated = (state: RegionStore) => state._hasHydrated;
